exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-component='reset'] .reset-pass {\n  width: 100%;\n}\n[data-component='reset'] .reset-pass .form-reset-pass {\n  width: 220px;\n  display: inline-block;\n}\n[data-component='reset'] [data-component='signature'] {\n  margin: 40px 0 55px;\n}\n[data-component='reset'] [data-component='signature'] [data-component='virtual-num-pad'] {\n  margin: -37px 110px 0 110px;\n}\n[data-component='reset'] [data-component='virtual-num-pad'] {\n  margin: 55px 110px 0px 110px;\n  opacity: 0;\n  visibility: hidden;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/change-pass/reset/reset.component.styl
// module id = ../../../../../src/app/master/change-pass/reset/reset.component.styl
// module chunks = main